export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        radio('filter-and-search-changed').subscribe(updateCount);

        // FIXME: this whole thing obviously needs a big rewrite
        function updateCount(result) {
            result.filterWidgets.forEach(filter => {
                if (filter.taxonomyWidget) {
                    updateBranchCount(filter.root.children);
                } else if (filter.categorySpecificTaxonomyWidget) {
                    updateBranchCount(filter.root.children);
                } else if (filter.popularTaxonomyWidget) {
                    updateBranchCount(filter.root.children);
                } else if (filter.taxonomyTreeWidget) {
                    updateTaxonomyTreeCount(filter.root.children);
                } else if (filter.multiSelectWidget) {
                    const widgetName = filter.name;
                    updateMultiSelectCount(filter.filters, widgetName);
                } else if (filter.moreWidget) {
                    updateCount(filter.moreWidget);
                } else if (filter.singleBoolValueWithLinkWidget) {
                    const widgetName = filter.name;
                    updateSingleBoolCount(filter, widgetName);
                }
            });
        }

        function updateMultiSelectCount(filters, widgetName) {
            filters.forEach(filter => {
                // getElementById() is *much* quicker than querySelector() in Mobile IE
                const childEle = document.getElementById(
                    `count-${widgetName}-${filter.value}`
                );
                if (!childEle) {
                    return;
                }

                childEle.textContent = `(${filter.hitCount})`;
                const hasHits = filter.hitCount !== '0';
                const ele = childEle.closest('[data-multiselect-item]');
                ele
                    .querySelector('[data-multiselect-label]')
                    .classList.toggle('no-hits', !hasHits);
                ele.querySelector('[data-multiselect-input]').tabIndex = hasHits
                    ? 0
                    : -1; // let it be checkable, but not reachable by tab
            });
        }

        function updateSingleBoolCount(filter, widgetName) {
            // getElementById() is *much* quicker than querySelector() in Mobile IE
            const childEle = document.getElementById(
                `count-${widgetName}-${filter.value}`
            );
            if (!childEle) {
                return;
            }

            childEle.textContent = `(${filter.hitCount})`;
            const hasHits = filter.hitCount !== '0';

            const ele = childEle.closest('[data-single-bool]');
            ele.querySelector('label').classList.toggle('no-hits', !hasHits);
            ele.querySelector('input').tabIndex = hasHits ? 0 : -1; // let it be checkable, but not reachable by tab
        }

        function updateTaxonomyTreeCount(branch) {
            branch.forEach(child => {
                if (child.children.length > 0) {
                    updateTaxonomyTreeCount(child.children);
                }

                // getElementById() is *much* quicker than querySelector() in Mobile IE
                const childEle = document.getElementById(
                    `count-${child.name}-${child.value}`
                );
                if (!childEle) {
                    return;
                }

                const childHeaderCounterEle = document.getElementById(
                    `header-count-${child.name}-${child.value}`
                );
                if (childHeaderCounterEle) {
                    childHeaderCounterEle.textContent = `(${child.hitCount})`;
                }

                childEle.textContent = `(${child.hitCount})`;
                const hasHits = child.hitCount !== '0';
                const nodeLinkEle = childEle.closest('[data-node-link]');
                const fancyInputEle = childEle.closest('.fancyinput');
                if (nodeLinkEle) {
                    nodeLinkEle.classList.toggle('no-hits', !hasHits);
                    nodeLinkEle.querySelector(
                        '.taxonomy-nodelink'
                    ).tabIndex = hasHits ? 0 : -1;
                } else if (fancyInputEle) {
                    fancyInputEle.classList.toggle('no-hits', !hasHits);
                    const inputEle = fancyInputEle.querySelector('input');
                    if (inputEle) {
                        inputEle.tabIndex = hasHits ? 0 : -1; // let it be checkable, but not reachable by tab
                    }
                }
            });
        }

        function updateBranchCount(branch) {
            branch.forEach(child => {
                if (child.children.length > 0) {
                    updateBranchCount(child.children);
                }

                // getElementById() is *much* quicker than querySelector() in Mobile IE
                const childEle = document.getElementById(
                    `count-${child.name}-${child.value}`
                );
                if (!childEle) {
                    return;
                }

                childEle.textContent = `(${child.hitCount})`;
                const hasHits = child.hitCount !== '0';
                const ele = childEle.closest('[taxonomy-checkbox]');
                if (!ele) {
                    return;
                }
                ele
                    .querySelector('label')
                    .classList.toggle('no-hits', !hasHits);
                ele.querySelector('input').tabIndex = hasHits ? 0 : -1; // let it be checkable, but not reachable by tab
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/updateFilterCount.js